const allNavList = [
  {
    title: "문해력·수리력(S-PLAN)",
    path: "/exam/s-plan",
    activeColor: "var(--main-splan-primary)",
    children: [
      { title: "검사 개요", path: "/exam/s-plan/overview" },
      { title: "시행 안내", path: "/exam/s-plan/implementation" },
      { title: "검사 방법 안내", path: "/exam/s-plan/method" },
      { title: "검사 결과 안내", path: "/exam/s-plan/result" },
    ],
  },
  {
    title: "AI·디지털",
    path: "/exam/ai-literacy",
    activeColor: "var(--main-ai-primary)",
    children: [
      { title: "검사 개요", path: "/exam/ai-literacy/overview" },
      { title: "시행 안내", path: "/exam/ai-literacy/implementation" },
      { title: "검사 방법 안내", path: "/exam/ai-literacy/method" },
      { title: "검사 결과 안내", path: "/exam/ai-literacy/result" },
    ],
  },
  {
    title: "AI·서논술형(채움AI)",
    path: "/exam/essay",
    activeColor: "var(--main-essay-primary)",
    children: [
      { title: "검사 개요", path: "/exam/essay/overview" },
      { title: "시행 안내", path: "/exam/essay/implementation" },
      { title: "검사 방법 안내", path: "/exam/essay/method" },
      { title: "검사 결과 안내", path: "/exam/essay/result" },
    ],
  },
  {
    title: "나의 검사",
    path: "/my-test",
    children: [
      { title: "학교 구성원 관리", path: "/my-test/teacher/manage-members", requiresSchoolAdmin: true },
      { title: "진단검사 접수", path: "/my-test/teacher/register-exam", requiresSchoolAdmin: true },
      { title: "사전 점검", path: "/my-test/teacher/pre-check" },
      { title: "시험 감독", path: "/my-test/teacher/watch" },
      { title: "채점관리", path: "/my-test/teacher/grading", requiresGradingAccess: true },
      { title: "검사 결과", path: "/my-test/teacher/result" },
      { title: "응시하기", path: "/my-test/student/apply" },
      { title: "검사 결과", path: "/my-test/student/result" },
    ],
  },
  {
    title: "공지·문의",
    path: "/board",
    children: [
      { title: "공지사항", path: "/board/notice" },
      { title: "진단검사 기술지원", path: "/board/tech-support" },
      { title: "1:1 문의", path: "/board/inquiry" },
    ],
  },
];

const sitemapNavList = [
  {
    title: "문해력·수리력",
    path: "/exam/s-plan",
    activeColor: "var(--main-splan-primary)",
    children: [
      { title: "검사 개요", path: "/exam/s-plan/overview" },
      { title: "시행 안내", path: "/exam/s-plan/implementation" },
      { title: "검사 방법 안내", path: "/exam/s-plan/method" },
      { title: "검사 결과 안내", path: "/exam/s-plan/result" },
    ],
  },
  {
    title: "AI·디지털 리터러시",
    path: "/exam/ai-literacy",
    activeColor: "var(--main-ai-primary)",
    children: [
      { title: "검사 개요", path: "/exam/ai-literacy/overview" },
      { title: "시행 안내", path: "/exam/ai-literacy/implementation" },
      { title: "검사 방법 안내", path: "/exam/ai-literacy/method" },
      { title: "검사 결과 안내", path: "/exam/ai-literacy/result" },
    ],
  },
  {
    title: "서·논술형",
    path: "/exam/essay",
    activeColor: "var(--main-essay-primary)",
    children: [
      { title: "검사 개요", path: "/exam/essay/overview" },
      { title: "시행 안내", path: "/exam/essay/implementation" },
      { title: "검사 방법 안내", path: "/exam/essay/method" },
      { title: "검사 결과 안내", path: "/exam/essay/result" },
    ],
  },
  {
    title: "나의 검사",
    path: "/my-test",
    children: [
      { title: "학교 구성원 관리", path: "/my-test/teacher/manage-members", requiresSchoolAdmin: true },
      { title: "진단검사 접수", path: "/my-test/teacher/register-exam", requiresSchoolAdmin: true },
      { title: "사전 점검", path: "/my-test/teacher/pre-check" },
      { title: "시험 감독", path: "/my-test/teacher/watch" },
      { title: "채점관리", path: "/my-test/teacher/grading", requiresGradingAccess: true },
      { title: "검사 결과", path: "/my-test/teacher/result" },
      { title: "응시하기", path: "/my-test/student/apply" },
      { title: "검사 결과", path: "/my-test/student/result" },
    ],
  },
  {
    title: "공지·문의",
    path: "/board",
    children: [
      { title: "공지사항", path: "/board/notice" },
      { title: "진단검사 기술지원", path: "/board/tech-support", requiresTeacher: true },
      { title: "1:1 문의", path: "/board/inquiry", requiresTeacher: true },
    ],
  },
];

export { allNavList, sitemapNavList };
